$(window).on("load", function() {
    "use strict";

    $(window).on("scroll", function () {
        if($(document).scrollTop() > 100) {
          if($("#toTop").is(":hidden")) {
            $("#toTop").show();
          }
       } else {
          if($("#toTop").is(":visible")) {
            $("#toTop").hide();
          }
        }
    });

   
    //  RESPONSIVE MOBILE MENU 

  	//$("header nav ul ul").parent().addClass("active");

  	$(".menu-btn").on("click", function(){
      $(".responsive-mobile-menu").toggleClass("active");
      return false;
    });

    $(".close-menu, html").on("click", function(){
      $(".responsive-mobile-menu").removeClass("active");
    });

    $(".responsive-mobile-menu ul ul").parent().addClass("menu-item-has-children");
    $(".responsive-mobile-menu ul li.menu-item-has-children > a").on("click", function() {
      $(this).parent().toggleClass("active").siblings().removeClass("active");
      $(this).next("ul").slideToggle();
      $(this).parent().siblings().find("ul").slideUp();
      return false;
    });

    $(".close-menu, .responsive-mobile-menu").on("click", function(e) {
      e.stopPropagation();
    });


    // PAGE LOADER 

    //$(".page-loading").fadeOut();

    // SCROLL TO TOP BUTTON

	  $('#toTop').on("click", function(e){
        e.preventDefault();
        $('html, body').animate({scrollTop : 0},1000);
        return false;
    });
    

	// handle links with @href started with '#' only
	  /*$(document).on('click', 'a[href^="#"]', function(e) {
	    // target element id
	    var id = $(this).attr('href');

      //alert(id);
	    // target element
	    //var $id = $(id);
      
	    if ($(this).length === 0) {
	        return;
	    }

	    // prevent standard hash navigation (avoid blinking in IE)
	    e.preventDefault();

	    // top position relative to the document
	    var pos = $(this).offset().top;

	    // animated top scrolling
	    $('body, html').animate({scrollTop: pos});
	  });*/

    $(document).on('click', 'a[href^="#"]', function(e) {
      e.preventDefault();
     });


    // TOGGLE BUTTONS

    /*$(".toggle").each(function(){
        $(this).find('.content').hide();
        $(this).find('h2:first').addClass('active').next().slideDown(500).parent().addClass("activate");
        $('h2', this).on("click touchstart", function() {
            if ($(this).next().is(':hidden')) {
                $(this).parent().parent().parent().find("h2").removeClass('active').next().slideUp(500).removeClass('animated fadeInUp').parent().removeClass("activate");
                $(this).toggleClass('active').next().slideDown(500).addClass('animated fadeInUp').parent().toggleClass("activate");
            }
        });
    });*/

    // ANIMATION ON DEFAULT THEME BUTTTON

    $('.btn-default').on('mouseenter', function(e) {
      var parentOffset = $(this).offset(),
      relX = e.pageX - parentOffset.left,
      relY = e.pageY - parentOffset.top;
      $(this).find('span').css({top:relY, left:relX})
    }).on('mouseout', function(e) {
      var parentOffset = $(this).offset(),
      relX = e.pageX - parentOffset.left,
      relY = e.pageY - parentOffset.top;
      $(this).find('span').css({top:relY, left:relX})
    });

    $(".langSelection").each(function() {
      var i = 1;
      $(this).on('change', function(e) {
        var taal = $(this).val();
        var page = $("#LanguagePage").val();
        $.ajax({
            type: "POST",
            url: "/ajax/ajax_SwitchTrans.php",
            data: "t="+taal+"&p="+page,
            dataType: "json",
            cache: false,
          }).done(function (data) {
            window.location.href = data.url;
          });
      });
      i++;
    });

    var _container = jQuery('.mix-grid');
		if(_container.length > 0) {
        var mixer = mixitup(_container);
        jQuery("ul.mix-filter a").bind("click", function(e) {
          e.preventDefault();
        });
		}

    

});
